import type { $Fetch } from 'ofetch';
import type { CommissionEntry } from '@/domain/model/Commission';
import type { Page } from '@/domain/model/Page';
import type { CommissionEntryGateway, ListCommissionEntriesParams } from '@/application/port/out/CommissionEntryGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/commission-entries';

export class HttpCommissionEntryGateway implements CommissionEntryGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: ListCommissionEntriesParams): Promise<Page<CommissionEntry>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.vendedorUserId) params['vendedorUserId'] = p.vendedorUserId;
    if (p.vendaId) params['vendaId'] = p.vendaId;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<CommissionEntry>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async apropriar(id: string): Promise<CommissionEntry> {
    const res = await this.client<ApiResponse<CommissionEntry>>(
      `${PATH}/${encodeURIComponent(id)}/apropriar`, { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async pagar(id: string): Promise<CommissionEntry> {
    const res = await this.client<ApiResponse<CommissionEntry>>(
      `${PATH}/${encodeURIComponent(id)}/pagar`, { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
